import { render, staticRenderFns } from "./DouYinGoods.vue?vue&type=template&id=984d4b0a&scoped=true"
import script from "./DouYinGoods.vue?vue&type=script&lang=js"
export * from "./DouYinGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "984d4b0a",
  null
  
)

export default component.exports